import Backbone from 'backbone';
import Control from './Control';

export default Backbone.Collection.extend({
  model: Control,
  modelId: function(attrs) {
    return attrs.control_id;
  }
});
